import sanEngg from '../../assets/About/san_engg.avif'
import sanTech from '../../assets/About/san_tech.avif'
import sanPlanners from '../../assets/About/san_planners.avif'
import { motion } from 'framer-motion'
import { FiArrowRight } from "react-icons/fi"

export default function SanGroups() {
    return (
        <section className="py-3 md:py-10 px-8 sm:px-6 lg:px-24">
            <div className="mx-auto max-w-7xl">

                <h2 className="font-bold text-2xl md:text-3xl lg:text-4xl my-6">
                    SAN Group of Companies
                </h2>

                <div className="flex flex-col sm:flex-row justify-around gap-6">

                    {/* CARD */}
                    {[{
                        img: sanTech,
                        year: '2018',
                        title: 'SAN Engineering Solutions',
                        desc: 'Expanded into engineering services and enterprise support.',
                        link:'https://www.sanengineeringsolutions.com/'
                    },
                    {
                        img: sanEngg,
                        year: '2022',
                        title: 'SAN Technovation Pvt Ltd',
                        desc: 'Formed as the digital product and technology arm of the SAN Group.',
                        link:'https://www.santechnovation.com/'
                    },
                    {
                        img: sanPlanners,
                        year: '2024',
                        title: 'SAN Planners & Building Designs',
                        desc: 'Entered infrastructure and civil design services.',
                        link: 'https://www.sanplanners.com/'

                    }].map((item, index) => (

                        <motion.div
                            key={index}
                            className="
                group relative w-full lg:max-w-[398px] md:max-h-[620px] h-[500px]
                rounded-3xl overflow-hidden cursor-pointer
                transition-all duration-700 ease-out
                hover:border-[3px] hover:border-secondary-600
              "
                            initial="rest"
                            whileHover="hover"
                            animate="rest"
                            onClick={() => window.open(item.link, '_blank')}

                        >

                            <img
                                src={item.img}
                                alt={item.title}
                                className="w-full h-[550px] object-cover rounded-3xl"
                                onContextMenu={(e) => e.preventDefault()}
                                draggable={false}
                            />

                            {/* YEAR BADGE */}
                            <div className="bg-white absolute py-1 px-5 rounded-full right-5 top-4">
                                <p className="text-secondary-500 text-base">{item.year}</p>
                            </div>

                            {/* CONTENT */}
                            <motion.div
                                className="
                  bg-white/80 backdrop-blur-sm
                  px-6 py-10 absolute bottom-0 w-full text-center
                "
                            >
                                {/* TITLE */}
                                <motion.p
                                    className="
                    font-medium
                    text-[18px] lg:text-[20px]
                    bg-clip-text text-transparent
                    bg-gradient-to-r from-[#2B5AA0] to-[#0092E4]
                    lg:group-hover:text-black
                    transition-all duration-700
                  "
                                    variants={{
                                        rest: { y: 0 },
                                        hover: { y: -12 }
                                    }}
                                >
                                    {item.title}
                                </motion.p>

                                {/* DESCRIPTION */}
                                {/* MOBILE + TABLET */}
                                <p className="block lg:hidden font-secondary text-[14px] text-gray-700 mt-1">
                                    {item.desc}
                                </p>

                                {/* DESKTOP (HOVER) */}
                                <motion.p
                                    className="hidden lg:block font-secondary text-[14px] text-gray-700 mt-1"
                                    variants={{
                                        rest: { y: 24, opacity: 0 },
                                        hover: { y: 0, opacity: 1 }
                                    }}
                                    transition={{
                                        type: "spring",
                                        stiffness: 220,
                                        damping: 18,
                                        mass: 0.9
                                    }}
                                >
                                    {item.desc}
                                </motion.p>

                                {/* CTA BUTTON */}
                                <motion.button
                                    className="
        group
        absolute bottom-2 left-1/2 -translate-x-1/2
        flex items-center justify-center
        w-8 h-8 lg:mr-0
        bg-white text-secondary-500
        rounded-full shadow-md

        opacity-100 pointer-events-auto
        lg:opacity-0 lg:pointer-events-none
        lg:group-hover:opacity-100 lg:group-hover:pointer-events-auto
transition-all duration-500
        group-hover:w-36 group-hover:rounded-full
    "
                                >
                                    {/* CENTER ARROW */}
                                    {/* <div
                                        className="
                      absolute inset-0
                      flex items-center justify-center
                      transition-all duration-500
                      group-hover/btn:opacity-0 group-hover/btn:scale-75
                    "
                                    >
                                        <FiArrowRight className="text-lg" />
                                    </div> */}

                                    {/* TEXT */}
                                    <div
                                        className="
                      absolute inset-0
                      flex items-center justify-center
                      pr-4 gap-2
                      text-sm font-semibold whitespace-nowrap
                      opacity-0 translate-x-4
                      transition-all duration-500
                      group-hover:opacity-100 group-hover:translate-x-0
                    "
                                    >
                                        Learn More <FiArrowRight className="text-lg" />
                                    </div>
                                </motion.button>

                            </motion.div>
                        </motion.div>

                    ))}
                </div>
            </div>
        </section>
    );
}
